import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import Icon from 'components/icon';
import { t, Trans } from 'translations';
import MigrosLoginButton from 'components/migros-login-button';
import Tooltip from 'components/tooltip';
import HeaderTooltip from './header-tooltip';
import { preHeader } from 'constants/menus';

function PreHeader({ openModal, userRegion, isAuthenticated, hasCumulus, isModalOpen }) {
    return (
        <div className="pre-header">
            <div className="grid--container pre-header--container grid--container__fluid">
                <div className="grid--row">
                    <button
                        aria-haspopup="true"
                        aria-expanded={isModalOpen}
                        aria-label={userRegion ? t('accessibility.label.update_zip') : t('zip.form.placeholder')}
                        className="pre-header--location grid--col"
                        onClick={() => openModal({
                            layout: 'zip-form',
                        })}>
                        <div className="pre-header--link">
                            <Icon className="pre-header--icon" symbol="location" size="medium"/>
                            <span>{userRegion ? userRegion.zip : <Trans path="zip.header.link"/>}</span>
                        </div>
                    </button>
                    <nav className="pre-header--menu grid--col">
                        <ul className="pre-header--list u-reset grid--row">
                            {preHeader({
                                isAuthenticated,
                                hasCumulus,
                            }).map((link, i) => (
                                <li className="pre-header--item" key={i}>
                                    <NavLink exact activeClassName="pre-header--link__is-active"
                                        className="pre-header--link u-reset"
                                        to={link.url}>{link.title}
                                    </NavLink>
                                </li>
                            ))}
                            <li className="pre-header--item">
                                <Tooltip facet="header-tooltip" interactionType="click" content={<HeaderTooltip/>}>
                                    <div className="pre-header--tooltip pre-header--link">
                                        <Trans path="menus.help"/>
                                        <Icon className="pre-header--icon" symbol="chevron-down" size="small"/>
                                    </div>
                                </Tooltip>
                            </li>
                        </ul>
                    </nav>
                    <div className="grid--col">
                        <MigrosLoginButton/>
                    </div>
                </div>
            </div>
        </div>
    );
}

PreHeader.propTypes = {
    userRegion: PropTypes.object,
    openModal: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    hasCumulus: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired, // this prop is needed to let this component update :(
};

export default connect(
    reduxUtils.mapStateToProps({
        isAuthenticated: 'user.isAuthenticated',
        hasCumulus: 'user.cumulus_connected',
        isModalOpen: 'modal.isVisible',
        userRegion: 'region.active',
        pathname: 'router.location.pathname',
    }),
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
    }),
)(PreHeader);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/pre-header/index.js